export default "__VITE_ASSET__DOqNIsNJ__"